<script setup lang="ts">
import { Head, router } from "@inertiajs/vue3"
import { ref } from "vue"

import FlashAlerts from "@/components/FlashAlerts.vue"
import NarrowPage from "@/components/NarrowPage.vue"
import { useNavbar } from "@/composables/useNavbar"
import { accountSettingsPath } from "@/routes"

const props = defineProps<{
  asset_code_prefix: string
  asset_code_example: string
}>()

const { title } = useNavbar({ title: "Account Settings" })

const prefix = ref(props.asset_code_prefix)
const saving = ref(false)

function save() {
  saving.value = true
  router.patch(
    accountSettingsPath(),
    { account: { asset_code_prefix: prefix.value } },
    { onFinish: () => (saving.value = false) },
  )
}
</script>

<template>
  <Head :title="title" />

  <NarrowPage>
    <FlashAlerts />

    <form class="flex flex-col gap-4" @submit.prevent="save">
      <UFormField label="Asset Code Prefix" hint="Max 4 characters, uppercase letters and numbers">
        <UInput v-model="prefix" maxlength="4" placeholder="NJ" class="w-32 font-mono uppercase" />
      </UFormField>

      <p class="text-muted text-sm">
        Preview: <span class="font-mono">{{ prefix ? `${prefix}-ABC123` : "ABC123" }}</span>
      </p>

      <UButton type="submit" label="Save" :loading="saving" class="self-start" />
    </form>
  </NarrowPage>
</template>
